import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/ticketTasks'

const findOne = (ticketTaskId, taskId, queryParams = '', organization) => AxiosClient.get(
  `${resource}/${ticketTaskId}/tasks/${taskId}?${queryParams}`, { headers: { organization } }
)

const update = (ticketTaskId, taskId, payload, organization) => AxiosClient.patch(
  `${resource}/${ticketTaskId}/tasks/${taskId}`, payload, { headers: { organization } }
)

export {
  findOne,
  update
}
